import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Chatbot from "./components/Chatbot";

import Home from "./pages/Home";
import Skill from "./pages/Skillset";
import Project from "./pages/Projects";
import Resume from "./pages/Resume";
import Contact from "./pages/Contact";
import Shell from "./pages/Shell";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Preloader from "./components/PreLoader";
import ScrollToTop from "./components/ScrollToTop";
import ThemeCustomizer from "./components/ThemeCustomizer";
import CustomCursor from "./components/CustomCursor";
import { playClickSound, playHoverSound } from "./utils/sound";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./style.css";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/skillset" element={<Skill />} />
        <Route path="/project" element={<Project />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shell" element={<Shell />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleGlobalClick = (e) => {
      const target = e.target;
      if (!target) return;
      const isClickable =
        target.tagName === "A" ||
        target.tagName === "BUTTON" ||
        target.closest("a") ||
        target.closest("button");

      if (isClickable && !target.closest(".theme-customizer-container")) {
        playClickSound();
      }
    };

    // Tracks which element we hovered last to prevent repeating sounds on same element
    let lastHoveredElement = null;

    const handleGlobalHover = (e) => {
      const target = e.target;
      if (!target) return;

      const interactiveEl =
        target.tagName === "A" ||
        target.tagName === "BUTTON" ||
        target.closest(".nav-link") ||
        target.closest(".project-card-view") ||
        target.closest(".home-social-icons") ||
        target.closest(".contact-social-icons") ||
        target.closest(".fork-btn-inner") ||
        target.closest(".like-btn");

      if (interactiveEl && !target.closest(".theme-customizer-container")) {
        const currentEl = target.closest("a") || target.closest("button") || target.closest(".project-card-view") || target;
        if (currentEl !== lastHoveredElement) {
          playHoverSound();
          lastHoveredElement = currentEl;
        }
      } else {
        lastHoveredElement = null;
      }
    };

    document.addEventListener("click", handleGlobalClick);
    document.addEventListener("mouseover", handleGlobalHover);

    return () => {
      document.removeEventListener("click", handleGlobalClick);
      document.removeEventListener("mouseover", handleGlobalHover);
    };
  }, []);

  return (
    <Router>
      <CustomCursor />
      <ThemeCustomizer />
      <Preloader load={load} />
      <Chatbot />
      <Link
        to="/shell"
        className="shell-floating-btn"
      >
        <span className="shell-floating-icon">&gt;</span>
      </Link>
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <AnimatedRoutes />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
